const InvalidCredentials = (attemptsLeft: number) => ({
  message: `This sign in information is incorrect. Please try again or click Forgot Password to recover a lost password. You have ${attemptsLeft} number of attempts before your account is locked.`,
  linkText: '',
  link: ''
});

const LockedAccount = () => ({
  message: 'Your account has been locked due to too many failed login attempts. ',
  linkText: 'Please reset your password.',
  link: ''
});

const NoAccountFound = () => ({
  message: 'Invalid username or password entered.',
  linkText: '',
  link: ''
});

const DisabledUser = () => ({
  message: 'user is disabled.'
})

const AwsCognitoErrorMessages = (attemptsLeft = 0) => ({
  NotAuthorizedException: InvalidCredentials(attemptsLeft),
  UserLambdaValidationException: LockedAccount(),
  UserNotFoundException: NoAccountFound()
});

export enum AuthExceptions {
  NotAuthorizedException = 'NotAuthorizedException',
  UserLambdaValidationException = 'UserLambdaValidationException',
  UserNotFoundException = 'UserNotFoundException',
  InvalidPasswordException = 'InvalidPasswordException'
};

export { AwsCognitoErrorMessages, NoAccountFound, DisabledUser };
